import { searchUnderstander } from "./modules";
import { mailHash, navigate } from "./router";
import { looksNatural } from "./search-query";

// Plain-language searches ("PDFs from Bob last week") go through a module that reads them (the
// AI module), which writes the operators; anything already written with operators, and every
// search when no such module is on, runs as typed.

/** The description each written query came from, so the results can show it. */
const descriptions = new Map<string, string>();

export const descriptionOf = (query: string) => descriptions.get(query);

const go = (query: string) => navigate(mailHash(`#/search/${encodeURIComponent(query)}`));

/** Runs what was typed in the search box, asking a module first when it reads as a description. */
export const runSearch = async (text: string) => {
  const typed = text.trim();
  if (!typed) return;
  const understand = searchUnderstander();
  if (!understand || !looksNatural(typed)) return go(typed);
  const query = await understand(typed).catch(() => null);
  if (!query) return go(typed);
  descriptions.set(query, typed);
  go(query);
};
